// extracted by mini-css-extract-plugin
module.exports = {"break":"ChatMessageList_break__e73_Y","reverser":"ChatMessageList_reverser__xziHV","msgItem":"ChatMessageList_msgItem__qdPYw"};